<template>
  <button :type="type" class="bs-button" :class="['bs-button--' + variant, { 'bs-button--icon': iconOnly }]" :disabled="disabled || loading" :aria-busy="loading ? 'true' : undefined">
    <slot />
  </button>
</template>
<script>
export default {
  props: {
    type: { type: String, default: 'button' },
    variant: { type: String, default: 'basic', validator: value => ['basic', 'primary', 'remove', 'text', 'inverse'].includes(value) },
    disabled: Boolean,
    loading: Boolean,
    iconOnly: Boolean
  }
};
</script>
